import {
    Component, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';
import { OnboardingService } from '../onboarding.service';
import { RecaptchaService } from '../recaptcha.service';
import { TelegramService } from '../../services/telegram.service';

declare let Telegram: any;

interface TelegramData {
    auth_date: number;
    first_name: string;
    hash: string;
    id: number;
    last_name: string;
    username: string;
    // I think there could be other properties too
}
@Component({
    selector: 'app-airdrop-telegram',
    templateUrl: './airdrop-telegram.component.html',
    styleUrls: [ './airdrop-telegram.component.scss' ]
})
export class AirdropTelegramComponent implements OnInit {
    width: any;
    @Input() task = {
        id: '',
        title: '',
        desc: '',
        icon: '',
        status: 'Pending',
        reward: 0,
        multiplier: false,
        redirect_url: '',
        cta: '',
        coming_soon: false
    };

    constructor(public httpService: HttpService,
        private telegramService: TelegramService,
        private cfAlertService: CfAlertService,
        private recaptchaService: RecaptchaService,
        private onboardingService: OnboardingService
    ) {
        this.window = getWindow();
        this.width = this.window.outerWidth;
    }
    
    use_manual_recaptcha: boolean = false;
    window: Window;

    public telegram: any = {
        loading: false,
        loginButton: true,
        serverJoined: false,
        checkGroupButton: false,
        checkGroupJoinedIntervalId: null,
        accountConnected: false,
        groupCheckAttempt: 0,
        verifying_group_joined: false
    };

    telegramJoined: boolean = false;
    telegram_join_loading: boolean = false;

    ngOnInit(): void {
        this.attachSocketEvents();
        console.log('this.httpService', this.httpService.user);
    }

    attachSocketEvents() {
        this.httpService.socket.on('telegram_group_joined', (data: any) => {
            console.log('telegram_group_joined socket => ', data);

            this.httpService.getCurrentUser();
        });
    }

    checkTelegramGroupJoined(showError: boolean) {
        // this.telegram.verifying_group_joined = true;
        this.telegramService.checkTelegramGroupJoined().subscribe((res) => {
            clearInterval(this.telegram.checkGroupJoinedIntervalId);

            this.cfAlertService.showSuccess(res.message);
            // this.telegram.verifying_group_joined = true;
            // this.httpService.user.telegram.verifying_group_joined = true;
        }, (err: HttpErrorResponse) => {
            console.error('checkTelegramGroupJoined error');
            console.error(err);

            if (showError)
                this.cfAlertService.showError(err);

            // this.telegram.verifying_group_joined = false;
            this.telegram.groupCheckAttempt++;

            if (this.telegram.groupCheckAttempt > 10)
                clearInterval(this.telegram.checkGroupJoinedIntervalId);
        });
    }
    loginWithTelegram(redirect_url:string) {
        const TELEGRAM_BOT_ID = '6562280465';

        const option = {
            bot_id: TELEGRAM_BOT_ID,
            request_access: true,
            lang: 'en'
        };

        if (!('Telegram' in this.window))
            return;

        console.log(this.window.Telegram);

        Telegram.Login.auth(option, (data: TelegramData) => {
            if (!data)
                console.log('authorization failed');

            console.log('data', data);

            if (!data.username) {
                this.cfAlertService.showMessage('Please set username on Telegram', true);

                return;
            }

            this.saveTelegramUser(data, redirect_url);
        });
    }
    saveTelegramUser(telegramLoginData: any, redirect_url:string) {
        this.telegramService.saveTelegramUser(telegramLoginData).subscribe((res) => {
            this.cfAlertService.showSuccess(res.message);
            this.window.location.href = redirect_url;
        }, (err: HttpErrorResponse) => {
            console.error('saveTelegramUser error');
            console.error(err);
    
            this.cfAlertService.showError(err);
        });
    }
    isPresent() {
        // console.log('phantom', 'phantom' in this.window);
        // console.log('solflare', 'solflare' in this.window);
        // console.log('ethereum', 'ethereum' in this.window);

        if ('phantom' in this.window || 'solflare' in this.window || 'ethereum' in this.window)  
            return true;
        else return false;
    }
    connectTelegram() {
        // if (this.width > 768)
        //     this.window.open(this.task.redirect_url, '_blank');
        // console.log(this.window);

        if (this.width < 768 && this.isPresent()) {
            this.cfAlertService.showMessage('This feature works best in Chrome or Safari. Please use one of these browsers.', true);

            return;
        }
        
        else this.loginWithTelegram(this.task.redirect_url);
    }

    async apiCall(body: any) {
        const recaptcha = await this.recaptchaService.getRecaptcha('joinSocialMedia', this.use_manual_recaptcha);

        body = {
            ...body, 
            ...recaptcha
        };
        this.onboardingService.updateSocialMedia(body).subscribe((res: any) => {
            this.cfAlertService.showMessage(res.message);
        }, (err: HttpErrorResponse) => {
            console.error('refferal code update error');
            console.error(err);

            if (err.error.message === 'Invalid recaptcha') {
                this.use_manual_recaptcha = true;
                this.apiCall(body);

                return ;
            }

            this.cfAlertService.showError(err);
        });
    }
}
